import React from 'react';
import { FullListing } from '@th/shared/src/types/FullListing';
import formatRepliersImageSource from '@th/shared/src/helpers/formatRepliersImageSource';
import blurText from '../../helpers/blurText';
import ListingAddress from './ListingAddress';
import ListingSpaceSummary from './ListingSpaceSummary';
import { twMerge } from 'tailwind-merge';
import UnauthenticatedCarouselOverlay from './UnauthenticatedCarouselOverlay';
import {
  DEFAULT_IMAGE_RESOLUTION,
  FULL_IMAGE_RESOLUTION,
} from '@th/frontend-shared/src/constants/images';
import Link from 'next/link';
import LinkWrapper from '../LinkWrapper';

type Props = {
  listing: FullListing;
  isBlurred?: boolean;
  className?: string;
};

export default function ListingImageCard({
  listing,
  isBlurred,
  className,
}: Props) {
  const listingImageUri =
    listing.images.length > 0
      ? formatRepliersImageSource(listing.images[0], 'large').uri
      : '/images/imagePlaceholder.png';

  return (
    <div className="relative">
      <LinkWrapper href={`/l/${listing.id}`}>
        <div className="relative object-cover rounded-3xl overflow-hidden group">
          <img
            src={listingImageUri}
            alt={`Preview image for ${listing.address.formattedAddressShortOneLiner()}`}
            className={twMerge(
              'object-cover align-bottom aspect-3/2 transition-all  group-hover:scale-110 ',
              isBlurred && 'blur-sm',
              className,
            )}
          />
          <div
            className={twMerge(
              'absolute bottom-0 left-0 bg-gradient-to-t from-semiTransparentDarkestGray to-transparent w-full rounded-b-3xl h-full md:h-1/2',
              className,
            )}
          >
            <div className="flex flex-col justify-end items-start h-full p-4 text-white">
              <h3 className={twMerge('mb-1', isBlurred && 'blur-xs')}>
                {blurText(listing.displayPrice(), isBlurred)}
              </h3>
              <ListingSpaceSummary
                listing={listing}
                isBlurred={isBlurred}
                includeSqft={false}
                textClassName="text-white"
              />
              <ListingAddress listing={listing} isBlurred={isBlurred} />
            </div>
          </div>
        </div>
      </LinkWrapper>
      {isBlurred && <UnauthenticatedCarouselOverlay small={true} />}
    </div>
  );
}
